"use strict";var t=require("styled-components");exports.aspectRatioPolyfill=e=>t.css`
  @supports not (aspect-ratio: auto) {
    &::before {
      float: left;
      padding-top: ${(t=>{const e=t.includes(":")?t.replace(":","/"):t,[o,s]=e.split("/").map((t=>parseInt(t.trim(),10)));return`${(s/o*100).toFixed(2)}%`})(e)};
      content: '';
    }

    &::after {
      display: block;
      content: '';
      clear: both;
    }
  }
`;
